import BaseRestService from "./BaseRestService";

class GroupService extends BaseRestService {
  async getGroupsByName(name) {
    const url = `api/groupservice/groups-by-name?groupName=${name}`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async getGroupById(groupId) {
    const url = `api/groupservice/group-by-id?groupId=${groupId}`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async getMembersOfGroup(groupId, start, limit) {
    const url = `api/groupservice/group-members?groupId=${groupId}&start=${start}&limit=${limit}`;
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async getPaginatedMembersOfGroup(requestUrl) {
    const url = `api/groupservice/paginated-group-members`;
    return this.client.post(
      url,
      { url: requestUrl },
      await this.buildJWTAuthAxiosConfig()
    );
  }
}

export const groupService = new GroupService();
